const SOLVIMAS_LOCAL_LOGO = "/templates/solvimas/logo.png";
const SOLVIMAS_WHATSAPP = "5593372348";

const GNP_SOLVIMAS_EMAILS = new Set([
  "maria.vidalcruz@solvimas.com",
  "beatriz.miguel@solvimas.com",
  "ary.mucino@solvimas.com",
  "roberto.bernal@gnp.com.mx",
  "brenda.duran@solvimas.com",
  "juan.poot@solvimas.com",
]);

// Usuarios con comportamiento Solvimas que deben mostrar su propio número
// real en vez del WhatsApp compartido (SOLVIMAS_WHATSAPP).
const SOLVIMAS_WHATSAPP_OVERRIDE_EXCEPTIONS = new Set([
  "victor.balcazar@gnp.com.mx",
]);

const normalizeEmail = (email) => String(email || "").trim().toLowerCase();
const isSolvimasDomainEmail = (email) =>
  normalizeEmail(email).endsWith("@solvimas.com");

export const isSolvimasBehaviorUser = ({ projectId, email }) => {
  if (projectId === "solvimas") {
    return true;
  }

  if (projectId !== "gnp") {
    return false;
  }

  return (
    isSolvimasDomainEmail(email) || GNP_SOLVIMAS_EMAILS.has(normalizeEmail(email))
  );
};

export const resolveWhatsappPhone = ({ projectId, email, phone }) => {
  const usesSharedWhatsapp =
    isSolvimasBehaviorUser({ projectId, email }) &&
    !SOLVIMAS_WHATSAPP_OVERRIDE_EXCEPTIONS.has(normalizeEmail(email));

  return usesSharedWhatsapp ? SOLVIMAS_WHATSAPP : phone;
};

export { isSolvimasDomainEmail, SOLVIMAS_LOCAL_LOGO, SOLVIMAS_WHATSAPP };
